/**
 * Business logic per Customers autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import customersService from '../services/customersService';
import type { CustomerAutocompleteResult } from '../models/customer';
import type { BaseAutocompleteOptions, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export async function getCustomersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: BaseAutocompleteOptions = {},
): Promise<CustomerAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		select: 'id,code,name',
		count: true,
		top: 20,
		orderBy: ['code'],
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(name)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({
			id: { eq: id },
		});
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [
				{
					id: {
						in: notInIds,
					},
				},
			],
		});
	}

	const result = await customersService.getCustomers(buildQuery(context));
	// ODataResponse<Customer> ha value: Customer[], compatibile con Pick<Customer, 'id' | 'code' | 'name'>[]
	return result.value;
}
